"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Mon Aug 06 2018
*/

var big_decimal_1 = require("@logio/big-decimal");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var RangeValidator_1 = require("../../../core/model/data-dictionary/validators/RangeValidator");

var Range_1 = require("../../../core/model/math/Range");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");

var RangeConstraint_1 = require("./RangeConstraint");
/**
 * The minimal and maximal margin that is expected.
 *
 * @author RV
 */


var Margin =
/*#__PURE__*/
function (_RangeConstraint_1$Ra) {
  _inherits(Margin, _RangeConstraint_1$Ra);

  /**
   * @inheritDoc
   */
  function Margin(range) {
    var _this;

    _classCallCheck(this, Margin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Margin).call(this, range));
    _this.range = range;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(Margin, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.Margin;
    }
  }]);

  return Margin;
}(RangeConstraint_1.RangeConstraint);

exports.Margin = Margin;
Margin.MIN_VALUE = 0;
Margin.MAX_VALUE = 10000000;
Margin.DEFAULT_RANGE = new Range_1.Range(big_decimal_1.bigdecimal(5), big_decimal_1.bigdecimal(100)); // tslint:disable-next-line:member-ordering

Margin.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RangeConstraint_1.RangeConstraint.name);
  return {
    range: builder.obj(Range_1.Range.name, Range_1.Range.schemaBigNumber, function (mat) {
      return new Range_1.Range(mat.minimum, mat.maximum);
    }, new RangeValidator_1.RangeValidator(Margin.MIN_VALUE, Margin.MAX_VALUE))
  };
}();